import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export function useCustomer() {
  const api = useApi()
  const [dataCustomer, setData] = useState<SelectOptionType[]>([])
  const [isLoadingCustomer, setLoading] = useState(true)

  useEffect(() => {
    api.get("/customer/")
    .then((res: SuccessFetch<{
      payload: {
        customer_id: string
        customer_name: string }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.customer_name, value: item.customer_id }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { dataCustomer, isLoadingCustomer }
}